import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import imageAttributes from 'util/react/image-attributes';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

export default function Teaser({ title, link, image }) {
    return (
        <section className="cms-teaser">
            <div className="cms-teaser--content">
                <h2 className="cms-teaser--title u-reset">{title}</h2>
                <div className="cms-teaser--button">
                    <Button facet="primary" size="small" tag="a" target={link.external ? '_blank' : '_self' } to={normaliseTrailingSlash(link.to)}>{link.text}</Button>
                </div>
            </div>
            <img className="cms-teaser--image" {...imageAttributes(image)}/>
        </section>
    );
}

Teaser.propTypes = {
    image: PropTypes.shape({
        src: PropTypes.object.isRequired,
        title: PropTypes.string,
        alt: PropTypes.string,
    }),
    title: PropTypes.string.isRequired,
    link: PropTypes.shape({
        to: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    }),
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/teaser/index.js